import { NumberFormat } from '@billy/design-system'

export const formatVatRatePercent = (vatRatePercent: number | undefined, locale: string): string =>
  `${NumberFormat.getPercentNumber(vatRatePercent, locale)}`
